import { VideoFields } from '@vimeo/gctl-api/models/components/schemas/video/Video';

import type { AlbumSortConfig, AlbumSortKey } from './types';

export const DEFAULT_BRAND_COLOR_DARK_THEME = '#F9FAFB';

export const SORT_ALPHABETICAL = 'alphabetical';
export const SORT_NEWEST = 'newest';
export const SORT_OLDEST = 'oldest';
export const SORT_LIKES = 'likes';
export const SORT_PLAYS = 'plays';
export const SORT_COMMENTS = 'comments';
export const SORT_ARRANGED = 'arranged';
export const SORT_ADDED_FIRST = 'added_first';
export const SORT_ADDED_LAST = 'added_last';
export const SORT_MODIFIED_NEWEST = 'modified_time_desc';
export const SORT_MODIFIED_OLDEST = 'modified_time_asc';

export const DEFAULT_SORT: AlbumSortConfig = {
  sort: 'default',
};

export const ALBUM_SORT_MAP: Record<AlbumSortKey, AlbumSortConfig> = {
  [SORT_ALPHABETICAL]: {
    sort: 'alphabetical',
    direction: 'asc',
  },
  [SORT_NEWEST]: {
    sort: 'date',
    direction: 'desc',
  },
  [SORT_OLDEST]: {
    sort: 'date',
    direction: 'asc',
  },
  [SORT_LIKES]: {
    sort: 'likes',
    direction: 'desc',
  },
  [SORT_PLAYS]: {
    sort: 'plays',
    direction: 'desc',
  },
  [SORT_COMMENTS]: {
    sort: 'comments',
    direction: 'desc',
  },
  [SORT_ARRANGED]: { sort: 'manual' },
  [SORT_ADDED_FIRST]: DEFAULT_SORT,
  [SORT_ADDED_LAST]: DEFAULT_SORT,
  [SORT_MODIFIED_NEWEST]: {
    sort: 'modified_time',
    direction: 'desc',
  },
  [SORT_MODIFIED_OLDEST]: {
    sort: 'modified_time',
    direction: 'asc',
  },
};

export const ITEMS_PER_PAGE = 20;
export const ITEMS_PER_PAGE_MOBILE = 10;

export const VIDEOS_API_VERSION = '3.4.12';

export const SELECT_ALBUM_FIELDS: VideoFields[] = [
  'badge.type',
  'duration',
  'isFree',
  'link',
  'live', // TODO: get all live data for now, eventually we need less than this
  'name',
  'pictures.sizes.link',
  'pictures.sizes.width',
  'pictures.uri',
  'privacy.download',
  'uri',
  'user.link',
  'user.name',
  'user.pictures.sizes.link',
  'user.pictures.sizes.width',
  'user.uri',
  'embedPlayerConfigUrl',
  'playerEmbedUrl',
];

export const NAV_HEIGHT = 63;
export const ADVANCED_CONTROLS_FLAG = 'ADVANCED_CONTROLS';

export const VIDEO_MODAL_TYPE = {
  VIDEO: 'video',
  ALBUM_VIDEO: 'albumVideo',
} as const;

export const FEATURED_FLAG_KEYS = {
  SHOW_NEW_CUSTOMIZE_CONTROLS: 'SHOW_NEW_CUSTOMIZE_CONTROLS',
} as const;

export const DEFAULT_SHOWCASE_PLAYER_RESPONSIVE_QUERY = {
  /** Disable "transparent" so the player is sized correctly inline */
  transparent: 0,
};
